require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-is-code-fellows-better-than-a-four-year-degree.json") })
        }
      }, "path---blog-is-code-fellows-better-than-a-four-year-degree");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-is-code-fellows-better-than-a-four-year-degree!./.cache/json/blog-is-code-fellows-better-than-a-four-year-degree.json
// module id = 913
// module chunks = 231608221292675